import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';

/** Provincia del catálogo journey (`GET /provinces`). */
export interface IProvince {
	uuid: string;
	name: string;
	code: string | null;
	country_code: string;
}

export interface IProvincesResponse {
	provinces: IProvince[];
}

@Injectable({
	providedIn: 'root',
})
export class ProvinceService extends ApiService {
	/**
	 * Lista provincias/subdivisiones de un país (ISO-3).
	 * Valor persistido en filled-forms: `name` (no uuid/code).
	 */
	public getProvinces(countryCode: string): Observable<IProvincesResponse> {
		return this.http.get<IProvincesResponse>(`${environment.identity2}/provinces`, {
			headers: this.getHeaders(),
			params: { country_code: countryCode },
		});
	}
}
